export type Visibility = 'HIGH' | 'LOW' | 'LOWREVERT' | 'SUCCESS' | 'ALERT';

export function fromVisibility(visibility: Visibility): string {
    switch (visibility) {
        case 'HIGH':
            return '_high';
        case 'LOWREVERT':
            return '_lowRevert';
        case 'LOW':
            return '_low';
        case 'SUCCESS':
            return '_success';
        case 'ALERT':
            return '_alert';
    }
}

export type Size = 'LARGE' | 'DEFAULT' | 'SMALL' | 'TINY';


export function fromSize(size: Size): string {
    switch (size) {
        case 'LARGE':
            return '_large';
        case 'DEFAULT':
            return '_default';
        case 'SMALL':
            return '_small';
        case 'TINY':
            return '_tiny';
    }
}
